import ShareIcon from "components/IconsSvg/ShareIcon";
import React, { useState } from "react";
import { ShareDiv, ShareLinkPopup } from "styles/jss/Home.styles";
import { useTranslation } from "next-i18next";

export default function ShareButton ({ newsUrl }) {
  const [showPopup, setShowPopup] = useState(false);
  const { t } = useTranslation(["article"]);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(newsUrl)
      .then(() => {
        alert(t('news.link-copied'));
      })
      .catch(err => {
        console.error("Failed to copy: ", err);
      });
  };

  return (
    <ShareDiv>
      <div className="date" onClick={togglePopup}>
        <i>
          <ShareIcon />
        </i>
        <span>{t("news.share")}</span>
      </div>
      {showPopup && (
        <ShareLinkPopup className="share-popup">
          <div className="share-popup">
            <label className="copy-instruction">
              {t("news.copy-link")}
            </label>
            <div className="url-box" onClick={copyToClipboard}>
              {newsUrl}
            </div>
            <button onClick={togglePopup} className="close-button">
              X
            </button>
          </div>
        </ShareLinkPopup>
      )}
    </ShareDiv>
  );
};
